import enLocale from 'vant/es/locale/lang/en-US';
import apiMsgKeysFlatZhCn from '../api-msg-keys-flat.zh-cn.json';

export const lang = {
  vant: enLocale,
  tjcg: '提交成功',
  gmcg: '购买成功',
  ts: '提示',
  qrz: '去认证',
  qx: '取消',
  qxzwj: '请选择文件',
  yjs: '已结束',
  fl: '分类',
  bkzh: '不可置换',
  yrz: '已认证',
  kzh: '可置换',
  cpjs: '产品介绍',
  xzrq: '选择日期',
  qd: '确定',
  qxz: '请选择',
  xlsx: '下拉刷新',
  zzsx: '正在刷新',
  'zzsx...': '正在刷新...',
  zzjz: '正在加载',
  'zzjz...': '正在加载...',
  ddl: '到底了',
  jzgd: '加载更多',
  mygdl: '没有更多了',
  sxcg: '刷新成功',
  sxsb: '刷新失败',
  gdz: '滚动中',
  ycd: '已触底',
  xz: '选择',
  zdxz: '最多选择',
  x: '项',
  qsr: '请输入',
  qzqtx: '请正确填写',
  sj: '数据',
  cxcxz: '从相册选择',
  pz: '拍照',
  xzsp: '选择视频',
  qxzszdq: '请选择所在地区',
  qscsphtp: '请上传视频或图片',
  wjdxbncg: '文件大小不能超过',
  zzdkxj: '正在打开相机',
  pzcg: '拍照成功',
  pzsb: '拍照失败',
  pzgccc: '拍照过程出错',
  myxjqx: '没有相机权限',
  xyqx: '需要权限',
  qyxyyfwxjyjxpz: '请允许应用访问相机以进行拍照',
  zbjx: '准备就绪',
  myzdxc: '没有找到相册',
  qxcjygxc: '请先创建一个相册',
  tpybcdxc: '图片已保存到相册',
  bcsb: '保存失败',
  djck: '点击查看',
  tj: '添加',
  tbz: '同步中',
  tbsb: '同步失败',
  ljz: '连接中',
  ljsb: '连接失败',
  ssz: '搜索中',
  jzz: '加载中',
  xx: '消息',
  txl: '通讯录',
  gzt: '工作台',
  wd: '我的',
  hysy: '欢迎使用',
  ssjgwk: '搜索结果为空',
  nyytxxx: '你有一条新消息',
  lx: '离线',
  zx: '在线',
  gly: '管理员',
  qz: '群主',
  ql: '群聊',
  qnc: '群昵称',
  jrsj: '加入时间',
  rqfs: '入群方式',
  swgly: '设为管理员',
  szjy: '设置禁言',
  grzl: '个人资料',
  yqjq: '邀请进群',
  smjq: '扫码进群',
  ssjq: '搜索进群',
  cy: '成员',
  qcy: '群成员',
  gd: '更多',
  qlyz: '群聊验证',
  qcyqx: '群成员权限',
  zrqz: '转让群主',
  byxckqtqcyzl: '不允许查看其他群成员资料',
  byxtjqcywhy: '不允许添加群成员为好友',
  qxjy: '取消禁言',
  zdy: '自定义',
  wb: '文本',
  tp: '图片',
  sp: '视频',
  wj: '文件',
  mp: '我的名片',
  xxyx: '消息已选',
  xxjsrlb: '消息接收人列表',
  qbyd: '全部已读',
  yd: '已读',
  wd_1: '未读',
  rwd: '人未读',
  cjql: '创建群聊',
  qmsy: '全面使用',
  jrql: '加入群聊',
  xglyhtdcyxw: '向管理员或团队成员询问',
  ljcj: '立即创建',
  sqjr: '申请加入',
  n: '你',
  sqtj: '申请添加',
  why: '为好友',
  yzxx: '验证信息',
  sqly: '申请理由',
  xzndtx: '选择你的头像',
  wjmm: '忘记密码',
  mm: '密码',
  qrmm: '确认密码',
  qzcqrndmm: '请再次确认您的密码',
  h: '和',
  yyzh: '已有账号',
  hmyzh: '还没有账号',
  ljzc: '立即注册',
  sjh: '手机号',
  w: '位',
  zsbhsz: '至少包含数字',
  zm: '字母',
  yzsjh: '验证手机号',
  qsrfsd: '请输入发送到',
  d: '的',
  wyzm: '位验证码',
  yxq: '有效期',
  fz: '分钟',
  zf: '重发',
  yzm: '验证码',
  m: '秒',
  zwsj: '暂无数据',
  ewm: '二维码',
  smewm: '扫描二维码',
  smewmmp: '扫描二维码名片',
  qewm: '群二维码',
  yh: '用户',
  xb: '性别',
  nc: '昵称',
  yhnc: '用户昵称',
  bz: '备注',
  xgnc: '修改昵称',
  nl: '年龄',
  sr: '生日',
  yx: '邮箱',
  s: '岁',
  bm: '保密',
  n_1: '女',
  n_2: '男',
  kq: '开启',
  gb: '关闭',
  zh: '综合',
  ltjl: '聊天记录',
  tjhy: '添加好友',
  dfyszbyxbtjwhy: '对方已设置不允许被添加为好友',
  tgs: '通过手',
  sstj: '搜索添加',
  tjqz: '添加群组',
  ss: '搜索',
  sphy: '视频会议',
  txgjl: '条相关记录',
  r: '人',
  hyyz: '好友验证',
  fxx: '发消息',
  qmc: '群名称',
  tx: '头像',
  qtx: '群头像',
  djsc: '点击上传',
  yq: '邀请',
  lxryx: '联系人已选',
  tjqcy: '添加群成员',
  ycqcy: '移除群成员',
  cj: '创建',
  sddqq: '收到的请求',
  fcdqq: '发出的请求',
  yxrhrjq: '允许任何人加群',
  xyfsyzxx: '需要发送验证消息',
  qcyyq: '群成员邀请',
  qcyyqwxyz: '群成员邀请无需验证',
  tjql: '添加群聊',
  cjptq: '创建普通群',
  cjgzq: '创建工作群',
  grxx: '个人信息',
  zfxx: '转发消息',
  jdltjl: '间的聊天记录',
  zdltjl: '中的聊天记录',
  zzsr: '正在输入',
  scz: '上传中',
  zw: '暂无',
  t: '条',
  sjzx: '手机在线',
  sys: '扫一扫',
  fqql: '发起群聊',
  lz: '录制',
  ssq: '搜索群',
  ly: '来源',
  dr: '的人',
  cz: '查找',
  hysz: '好友设置',
  szbz: '设置备注',
  bttjgpy: '把他推荐给朋友',
  jchygx: '解除好友关系',
  xgqlmc: '修改群聊名称',
  wzqldnc: '我在群里的昵称',
  txxx: '条新消息',
  hbzf: '合并转发',
  dltjl: '的聊天记录',
  syr: '所有人',
  txgltjl: '条相关聊天记录',
  wdwz: '我的位置',
  ckgdxglxr: '查看更多相关联系人',
  ckgdxgqz: '查看更多相关群组',
  ckgdxgltjl: '查看更多相关聊天记录',
  ckgdxgwd: '查看更多相关文档',
  zyqzjglykbj: '只有群主及管理员可编辑',
  qgl: '群管理',
  qyjy: '全员禁言',
  jqyz: '进群验证',
  qzglqzr: '群主管理权转让',
  qlsz: '群聊设置',
  wzbqdnc: '我在本群的昵称',
  zdql: '置顶群聊',
  ckqbqcy: '查看全部群成员',
  xttz: '系统通知',
  ksczltjl: '快速查找聊天记录',
  myzd: '没有找到',
  xgnr: '相关内容',
  ltsz: '聊天设置',
  zdlxr: '置顶联系人',
  yhjf: '阅后即焚',
  sjsz: '时间设置',
  zczhfsdxx: '在此之后发送的消息',
  hyydhhzxzdsjzhzdsc: '好友已读后会在选择的时间之后自动删除',
  yhzc: '用户注册',
  yqm: '邀请码',
  xt: '选填',
  szxx: '设置信息',
  xgmm: '修改密码',
  jmm: '旧密码',
  xmm: '新密码',
  yxz: '已选择',
  gbsgd: '关闭闪光灯',
  kqsgd: '开启闪光灯',
  dfyblrhmd: '对方已被拉入黑名单',
  nybzgqz: '您已不在该群组',
  qzhglyykqqtjy: '群主或管理员已开启全体禁言',
  gqzybjs: '该群组已被解散',
  gqzybfj: '该群组已被封禁',
  nybjy: '你已被禁言',
  qsrnc: '请输入昵称',
  qsryqm: '请输入邀请码',
  qsryzm: '请输入验证码',
  qsrqgg: '请输入群公告',
  qsrmm: '请输入密码',
  qqrsrmm: '请确认输入密码',
  qsrsjh: '请输入手机号',
  srxx: '输入信息',
  qsrqmc: '请输入群名称',
  zzlsrxx: '在这里输入消息',
  qsrndnc: '请输入你的昵称',
  wccj: '完成创建',
  qsryx: '请输入邮箱',
  ty: '同意',
  jj: '拒绝',
  qr: '确认',
  qclsxx: '清除历史消息',
  jsql: '解散群聊',
  tcql: '退出群聊',
  bc: '保存',
  fb: '发布',
  bj: '编辑',
  qc: '清除',
  jchy: '解除好友',
  ddyz: '等待验证',
  yjj: '已拒绝',
  yty: '已同意',
  fsyzm: '发送验证码',
  dl: '登录',
  yzmdl: '验证码登录',
  mmdl: '密码登录',
  sjhdl: '手机号登录',
  yxdl: '邮箱登录',
  sjhzc: '手机号注册',
  yxzc: '邮箱注册',
  sjhzhmm: '手机号找回密码',
  yxzhmm: '邮箱找回密码',
  zc: '注册',
  xg: '修改',
  jr: '进入',
  xyb: '下一步',
  yc: '移除',
  fssq: '发送申请',
  zd: '置顶',
  qxzd: '取消置顶',
  bjyd: '标记已读',
  fs: '发送',
  ck: '查看',
  azsh: '按住说话',
  skfs: '松开发送',
  skqx: '松开取消',
  yyxx: '语音消息',
  wjxx: '文件消息',
  tpxx: '图片消息',
  spxx: '视频消息',
  mpxx: '名片消息',
  szgly: '设置管理员',
  qgg: '群公告',
  sz: '设置',
  nqdytcgcym: '你确定要踢出该成员吗',
  qkltjl: '清空聊天记录',
  sch: '删除后',
  jwfckchhdxx: '将无法查看此会话的信息',
  qrqkltjlm: '确认清空聊天记录吗',
  xxmdr: '消息免打扰',
  pbxx: '屏蔽消息',
  qtjy: '全体禁言',
  jrhmd: '加入黑名单',
  zf_1: '转发',
  fz_1: '复制',
  ch: '撤回',
  dx: '多选',
  hf: '回复',
  sc: '删除',
  lxr: '联系人',
  cylxr: '常用联系人',
  xdhy: '新的好友',
  xdql: '新的群聊',
  wdhy: '我的好友',
  wdqz: '我的群组',
  sqrq: '申请入群',
  wdsq: '我的申请',
  ahyx: '按好友选',
  aqlx: '按群聊选',
  ajgx: '按架构选',
  zjhh: '最近会话',
  wcjd: '我创建的',
  wjrd: '我加入的',
  wdxx: '我的信息',
  hmd: '黑名单',
  yy: '语言',
  qcltjl: '清除聊天记录',
  zhsz: '账号设置',
  gywm: '关于我们',
  tcdl: '退出登录',
  sctsrz: '上传调试日志',
  txlhmd: '通讯录黑名单',
  wrms: '勿扰模式',
  xxxtsy: '新消息提示音',
  jztjwwhy: '禁止添加我为好友',
  wzxx: '位置消息',
  hbxx: '合并消息',
  zdyxx: '自定义消息',
  yyxx_1: '引用消息',
  bqxx: '表情消息',
  cg: '草稿',
  yr: '有人',
  zbzcdxxlx: '暂不支持的消息类型',
  tzxx: '通知消息',
  hyxx: '会议消息',
  yynrybch: '引用内容已被撤回',
  yy_1: '语音',
  wz: '位置',
  bq: '表情',
  th: '通话',
  d_1: '等',
  chlytxx: '撤回了一条消息',
  chlyt: '撤回了一条',
  fsdxx: '发送的消息',
  nmyjshyl: '你们已经是好友了',
  ksltb: '开始聊天吧',
  cjlql: '创建了群聊',
  xglqxx: '修改了群信息',
  xglqmcw: '修改了群名称为',
  xglqgg: '修改了群公告',
  zrlqzg: '转让了群主给',
  tclql: '退出了群聊',
  yql: '邀请了',
  tcl: '踢出了',
  jrlql: '加入了群聊',
  jslql: '解散了群聊',
  kqlqtjy: '开启了全体禁言',
  gblqtjy: '关闭了全体禁言',
  b: '被',
  jyl: '禁言了',
  qxljy: '取消了禁言',
  yhjfy: '阅后即焚已',
  hqzxztsb: '获取在线状态失败',
  hqqcysb: '获取群成员失败',
  ssxxsb: '搜索消息失败',
  hqyhxxsb: '获取用户信息失败',
  fsyzmsb: '发送验证码失败',
  gzhybzc: '该账号已被注册',
  zhwzc: '账号未注册',
  mmcw: '密码错误',
  lcsrdmmbyz: '两次输入的密码不一致',
  hq: '获取',
  sb: '失败',
  yzmcwhygq: '验证码错误或已过期',
  zcsb: '注册失败',
  dlsb: '登录失败',
  yzsb: '验证失败',
  xggrxxsb: '修改个人信息失败',
  czcg: '操作成功',
  czsb: '操作失败',
  fzcg: '复制成功',
  fzsb: '复制失败',
  sssb: '搜索失败',
  fsqqcg: '发送请求成功',
  fsqqsb: '发送请求失败',
  hqhhxxsb: '获取会话信息失败',
  bfxxscsb: '部分消息删除失败',
  nrbnwk: '内容不能为空',
  cjcg: '创建成功',
  scsb: '上传失败',
  sysqewm: '扫一扫群二维码',
  lkjrgq: '立刻加入该群',
  sysxmdewm: '扫一扫下面的二维码',
  tjwwhy: '添加我为好友',
  dqdlygq: '当前登录已过期',
  qcxdl: '请重新登录',
  ndzhyzqtsbdl: '您的账号已在其他设备登录',
  qdyfs: '确定要发送',
  dmpm: '的名片吗',
  fscg: '发送成功',
  fssb: '发送失败',
  yqcg: '邀请成功',
  yqsb: '邀请失败',
  qrjqzzg: '确认将群主转给',
  yccg: '移除成功',
  wsbdyxnr: '未识别到有效内容',
  nyjrgq: '你已加入该群',
  qrjchygx: '确认解除好友关系',
  xgcg: '修改成功',
  xgsb: '修改失败',
  sccg: '删除成功',
  hqqxsbhdqllqbzc: '获取权限失败或当前浏览器不支持',
  hqdw: '获取定位',
  hqdwsb: '获取定位失败',
  yqx: '已取消',
  lzsjtdl: '录制时间太短啦',
  scfmtsb: '生成封面图失败',
  jzsb: '加载失败',
  jsqlh: '解散群聊后',
  syqcyjsqhqydlx: '所有群成员将失去和群友的联系',
  tcqlh: '退出群聊后',
  qsrzqdsjh: '请输入正确的手机号',
  qsrzqdyx: '请输入正确的邮箱',
  mmgsbzq: '密码格式不正确',
  lcmmbyz: '两次密码不一致',
  xgmmcg: '修改密码成功',
  qdytcdlm: '确定要退出登录吗',
  qsrzqdyxzh: '请输入正确的邮箱账号',
  xs: '小时',
  t_1: '天',
  gg: '刚刚',
  bz_1: '本周',
  by: '本月',
  gz: '更早',
  xc: '相册',
  ps: '拍摄',
  spth: '视频通话',
  jtzw: '简体中文',
  yw: '英文',
  zhbcz: '账号不存在',
  sjhyzc: '手机号已注册',
  zhyzc: '账号已注册',
  czgypf: '操作过于频繁',
  qshzs: '请稍后再试',
  yzmcw: '验证码错误',
  yzmygq: '验证码已过期',
  yzmcwcscgxz: '验证码错误次数超过限制',
  yzmybsy: '验证码已被使用',
  yqmybsy: '邀请码已被使用',
  yqmbcz: '邀请码不存在',
  czxz: '操作限制',
  yyth: '语音通话',
  cswjt: '超时未接听',
  thsc: '通话时长',
  yzqtsbcl: '已在其他设备处理',
  jrsb: '加入失败',
  fqyqsb: '发起邀请失败',
  mkfyk: '麦克风已开',
  mkfyg: '麦克风已关',
  jt: '接听',
  gd_1: '挂断',
  ysqyk: '扬声器已开',
  ysqyg: '扬声器已关',
  ddjt: '等待接通',
  thz: '通话中',
  yqnyyth: '邀请你语音通话',
  yqnspth: '邀请你视频通话',
  zzhjz: '正在呼叫中',
  jrth: '加入通话',
  thjl: '通话记录',
  syth: '所有通话',
  wjth: '未接通话',
  hr: '呼入',
  hc: '呼出',
  zc_1: '种草',
  td: '探店',
  dh: '带货',
  tg: '通告',
  zhcgt: '种草',
  tdgt: '探店',
  ddgt: '带货',
  jcqxsb: '检查权限失败',
  qqqxsb: '请求权限失败',
  jrgxjc: '进入更新检测',
  xbbxx: '新版本信息',
  xbb: '新版本',
  jbb: '旧版本',
  yyxzjxz: '已有下载进行中',
  hlbccf: '忽略本次触发',
  xzwc: '下载完成',
  yzbhgx: '已准备好更新',
  xzsb: '下载失败',
  bbyz: '版本一致',
  wxgx: '无需更新',
  jcbbcc: '检测版本出错',
  dy: '调用',
  apgx: '安排更新',
  yygx: '应用更新',
  jhgxsb: '激活更新失败',
  wdtg: '我的通告',
  wdsc: '我的收藏',
  wdmp: '我的名片',
  tjmp: '添加名片',
  wddz: '我的地址',
  tjdz: '添加地址',
  tgq: '通告券',
  gzlb: '关注列表',
  gmjl: '购买记录',
  gmtgq: '购买通告券',
  zj: '足迹',
  tgzzy: '通告主主页',
  tgzrz: '通告主认证',
  bm_1: '报名',
  xtxx: '系统消息',
  drgc: '达人广场',
  sh: '审核',
  gzsc: '关注收藏',
  tgbm: '通告报名',
  xq: '详情',
  tbsc: '团币商城',
  dhxq: '兑换详情',
  qb: '钱包',
  cz_1: '充值',
  tx_1: '提现',
  txmx: '提现明细',
  mx: '明细',
  wdyhk: '我的银行卡',
  tjyhk: '添加银行卡',
  lx_1: '联系',
  fbtg: '发布通告',
  tgxq: '通告详情',
  sccg_1: '上传初稿',
  ptlj: '平台链接',
  jb: '举报',
  bmlb: '报名列表',
  sxbz: '筛选博主',
  zdydq: '自定义地区',
  ssgg: '搜索公告',
  bmcg: '报名成功',
  tjbjlj: '提交笔记链接',
  pj: '评价',
  ykyh: '游客用户',
  mt: '明天',
  zt: '昨天',
  n_3: '年',
  y: '月',
  r_1: '日',
  xhs: '小红书',
  dy_1: '抖音',
  jd: '进到',
  wlcw: '网络错误',
  wlcwqshzs: '网络错误，请稍后重试',
  ndyebzqcz: '您的余额不足，请充值',
  qshzs_1: '请稍后重试',
  dlygq: '登录已过期',
  yebz: '余额不足',
  ndyebz: '您的余额不足',
  qcz: '请充值',
  qcz_1: '去充值',
  xczs: '下次再说',
  qqsb: '请求失败',
  bq_1: '标签',
  bmdr: '报名的人',
  rbm: '人报名',
  ckbm: '查看报名',
  lxfs: '联系方式',
  bmhkj: '报名后可见',
  kgdr: '看过的人',
  rll: '人浏览',
  tgtj: '通告推荐',
  ysc: '已收藏',
  sc_1: '收藏',
  fx: '分享',
  jzsj: '截止时间',
  fsyq: '粉丝要求',
  tgpp: '推广品牌',
  zxsj: '执行时间',
  hzxs: '合作形式',
  bzyq: '博主要求',
  sysjkcy: '扫一扫即可参与',
  bchb: '保存海报',
  gbhb: '关闭海报',
  schb: '生成海报',
  sclj: '生成链接',
  bmcj: '报名参加',
  rsym: '人数已满',
  meym: '名额已满',
  ybm: '已报名',
  ygb: '已关闭',
  gnkfz: '功能开发中',
  dqhjbzcfz: '当前环境不支持复制',
  wzdhbnr: '未找到海报内容',
  zzschb: '正在生成海报',
  hbybcdwj: '海报已保存到文件',
  hbyxz: '海报已下载',
  bchbsb: '保存海报失败',
  qzs: '请重试',
  qrgbtg: '确认关闭通告',
  gtgjbzbgszgc: '该通告将不再被公示在广场',
  tgfb: '通告发布',
  qwfbzjf: '请勿发布直接发',
  dfdxjtg: '代发等虚假通告',
  jcxx: '基础信息',
  gf: '稿费',
  wgf: '无稿费',
  gd_2: '固定',
  qj: '区间',
  qsrgfjztbs: '请输入稿费价值团币数',
  qsrgfjztbzdz: '请输入稿费价值团币最低值',
  qsrgfjztbzgz: '请输入稿费价值团币最高值',
  hzfl: '合作福利',
  zp: '福利',
  wzp: '无福利',
  yzp: '有福利',
  zpms: '福利描述',
  qsrzpms: '请输入福利描述',
  zptbjz: '福利团币价值',
  qsrzptbjz: '请输入福利团币价值',
  yjsymb: '一键使用模版',
  bzlx: '博主类型',
  qxzbzlx: '请选择博主类型',
  tgwa: '文案',
  qxztgwa: '请选择文案',
  wyydbty: '我已阅读并同意',
  tgfwxy: '通告服务协议',
  yl: '预览',
  bt: '标题',
  qsrbhcpm: '请输入包含产品名',
  tdcsmdbt: '探店城市名的标题',
  pt: '平台',
  dhxs: '带货形式',
  zbdh: '直播带货',
  twgc: '图文挂车',
  spgc: '视频挂车',
  bx: '不限',
  sptbjz: '商品团币价值',
  tgf: '通告费',
  tb: '团币',
  hzyjtbjz: '合作佣金团币价值',
  yb: '邮编',
  szsf: '所在省份',
  szcs: '所在城市',
  ppmc: '品牌名称',
  xqme: '需求名额',
  qsrzzs: '请输入正整数',
  twsp: '图文视频',
  tw: '图文',
  dphj: '单品合集',
  dp: '单品',
  hj: '合集',
  jzrq: '报名截止日期',
  qxzjzrq: '请选择报名截止日期',
  fbyy: '发布语言',
  qzxfbyy: '请选择发布语言',
  yjhgbfdwk: '佣金和稿费不能都为空',
  rwmjzrq: '任务截止日期',
  xzrwmjzrq: '请选择任务截止日期',
  rwmjzbnzybmjzrq: '任务截止日期不能早于报名截止日期',
  qsrcpjs: '请输入产品介绍',
  sycj: '使用场景',
  bzdhsjyqd: '博主带货数据要求等',
  xh: '洗护',
  qc_1: '汽车',
  sp_1: '食品',
  cd: '穿搭',
  yxdm: '游戏动漫',
  cw: '宠物',
  mz: '美妆',
  kjsm: '科技数码',
  ys: '养生',
  ydcw: '运动潮玩',
  qt: '其他',
  gxcg: '更新成功',
  ddhtsh: '等待后台审核',
  qzyckxx: '请注意查看消息',
  qsrzqdgf: '请输入正确的稿费',
  qsrzqdjgqj: '请输入正确的价格区间',
  gfzdzyxygfzgz: '稿费最低值应小于稿费最高值',
  qsrzqdzpjz: '请输入正确的赠品价值',
  zpjzbnxy: '赠品价值不能小于',
  whz: '未合作',
  qsrssgjc: '请输入搜索关键词',
  jxz: '进行中',
  dsg: '待审稿',
  dfb: '待发布',
  ywc: '已完成',
  j: '旧',
  x_1: '新',
  tgyx: '通告优先',
  lyl: '聊一聊',
  ddtgzty: '等待通告主同意',
  bzsj: '博主视角',
  wbm: '未报名',
  dsgds: '待审稿都是',
  wlx: '未联系',
  ylxdwqr: '已联系但未确认',
  yqrhz: '已确认合作',
  yjjhz: '已拒绝合作',
  an: '按钮',
  yhzd: '已合作的',
  xccg: '先传初稿',
  ytjcghybhd: '已提交初稿或已驳回的',
  xgcg_1: '修改初稿',
  ckbj: '查看笔记',
  yshtg: '已审核通过',
  tjbj: '提交笔记',
  yfk: '已付款',
  ypj: '已评价',
  tgz: '通告主',
  shz: '审核中',
  shybh: '审核已驳回',
  ftgxx: '发通告消息',
  gbtg: '关闭通告',
  qbm: '去报名',
  wgs: '未过审',
  sytgq: '剩余通告券',
  zm_1: '招募',
  bz_2: '博主',
  qh: '切换',
  lz_1: '来自',
  fs_1: '粉丝',
  fy: '附言',
  tjgdmp: '添加更多名片',
  sjdz: '收件地址',
  qxzsjdz: '请选择收件地址',
  yhzh: '银行账号',
  qxzyhzh: '请选择银行账号',
  cjbm: '超级报名',
  qxzyptyzdmp: '请选择与平台一致的名片',
  fslbdbhsbm: '粉丝量不达标，不适合报名',
  qsrbt: '请输入标题',
  qzzlsrzw: '请在这里输入正文',
  cgyl: '初稿预览',
  bhcg: '驳回初稿',
  shtg: '审核通过',
  fhxg: '返回修改',
  qrsc: '确认上传',
  bh: '驳回',
  bhyy: '驳回原因',
  qsrbhyy: '请输入驳回原因',
  ylcg: '预览初稿',
  qtxbthzw: '请填写标题或正文',
  sccg_2: '上传成功',
  cgysc: '初稿已上传',
  qzstjzw: '请至少添加正文',
  tphsp: '图片或视频',
  qsrzsydzw: '请输入至少一段正文',
  qzsscyztphsp: '请至少上传一张图片或视频',
  qzsscyztp: '请至少上传一张图片',
  qrtgggjm: '确认通过该稿件吗',
  tgcg: '通过成功',
  cgytg: '初稿已通过',
  cgbh: '初稿驳回',
  cgybh: '初稿已驳回',
  c: '次',
  pf: '评分',
  me: '名额',
  ylwz: '预留位置',
  zctgkyzzlzs: '种草通告可以在这里展示',
  tgbh: '通告编号',
  nrxs: '内容形式',
  dq: '地区',
  zpfl: '赠品福利',
  zpjz: '赠品价值',
  hzyj: '合作佣金',
  qbpt: '全部平台',
  fssl: '粉丝数量',
  qbfl: '全部分类',
  zz: '重置',
  zwtg: '暂无通告',
  ys_1: '以上',
  ysdbjlsk: '元素顶部距离视口',
  xdzt: '吸顶状态',
  nha: '你好啊',
  fsyq_1: '发送邀请',
  qlmc: '群聊名称',
  ls: '李四',
  wsbz: '我是博主',
  hdh: '好的话',
  srxx_1: '输入消息',
  jyz: '禁言中',
  sdsmb: '说点什么吧',
  yfb: '已发布',
  yhs: '已合适',
  ytjcg: '已提交初稿',
  yxgtj: '已修改提交',
  shytg: '审核已通过',
  ytjbj: '已提交笔记',
  bzypj: '博主已评价',
  tgzwpj: '通告主未评价',
  tgzypj: '通告主已评价',
  bzwpj: '博主未评价',
  nyfk: '您已付款',
  qggpjb: '请给个评价吧',
  tglcxx: '通告流程消息',
  sggl: '三哥哥颅',
  lglglllsgg: '两个六公里了了三哥哥',
  sg: '审稿',
  cgyjtgl: '初稿已经通过了',
  wxcfsg: '无需重复审稿',
  fk: '付款',
  nyjfgkl: '您已经付过款了',
  wxcffk: '无需重复付款',
  dqzfxxh: '当前支付需消耗',
  tbzh: '团币折合',
  oy: '欧元',
  sfjx: '是否继续',
  fkcg: '付款成功',
  nyjpjgl: '您已经评价过了',
  tgywc: '通告已完成',
  wfpj: '无法评价',
  tjcg_1: '提交初稿',
  wxcftjcg: '无需重复提交初稿',
  fbbj: '发布笔记',
  rwjzrqygwfbm: '任务截止日期已过，无法报名',
  wxcftjbj: '无需重复提交笔记',
  tgyjs: '通告已结束',
  ysccg: '已上传初稿',
  yj: '佣金',
  jz: '价值',
  hs: '合适',
  bhs: '不合适',
  wfl: '无福利',
  dtjcg: '待提交初稿',
  dtjbj: '待提交笔记',
  dfk: '待付款',
  sdxx: '收到消息',
  xxnr: '消息内容',
  zxxxsj: '最新消息时间',
  zxxx: '最新消息',
  qjcfw: '请检查服务',
  ljcg: '连接成功',
  fwljsb: '服务连接失败',
  ljgb: '连接关闭',
  fscw: '发生错误',
  llqjdxxx: '浏览器接到新消息',
  khdzdgb: '客户端主动关闭',
  llqfcxx: '浏览器发出消息',
  fwxycs: '服务响应超时',
  ljcw: '连接错误',
  fsfs_1: '发送失败',
  fsfs_timeout: '消息发送超时，请稍后重试',
  fsfs_nosocket: '连接未初始化，发送失败',
  fsfs_connect_timeout: '连接建立超时，发送失败',
  fsfs_connect_error: '连接异常，发送失败',
  fsfs_connect_closed: '连接已断开，发送失败',
  fsfs_send_error: '消息发送出错，请稍后重试',
  fsfs_disconnect: '连接已断开，消息发送失败',
  jt_1: '今天',
  sz_1: '上周',
  nh: '你好',
  ysmkybndm: '有什么可以帮您的吗',
  qxx: '群消息',
  xxls: '消息历史',
  yxx: '原消息',
  q: '群',
  fm: '封面',
  wdsl: '未读数量',
  nmtjbchz: '匿名提交本次合作',
  hscpjks: '好事从评价开始',
  tj_1: '提交',
  shpj: '稍后评价',
  qgcpfhpjnr: '请给出评分和评价内容',
  ytjpj: '已提交评价',
  ldk: '来打卡',
  dksb: '打卡失败',
  dkcg: '打卡成功',
  xlsxcs: '下拉刷新测试',
  wsydxd: '我是有底线的',
  dw: '点我',
  wszcymfhdsj: '我是种草页面返回的数据',
  ndzsyqm: '您的专属邀请码',
  fzyqm: '复制邀请码',
  jyjtfxhtjgpyss: '建议截图分享或推荐给朋友搜索',
  bcewm: '保存二维码',
  fzfxlj: '复制分享链接',
  msfx: '马上分享',
  ggdl: '谷歌登录',
  xm: '项目',
  nh_1: '您好',
  qxzndjs: '请选择您的角色',
  wstgz: '我是通告主',
  yhyx: '用户邮箱',
  yzmyfs: '验证码已发送',
  qcs: '请查收',
  hqyzm: '获取验证码',
  hcxhq: '秒后重新获取',
  qsrzqyx: '请输入正确邮箱',
  ccl: '出错了',
  qsctx: '请上传头像',
  xby: '西班牙',
  gj: '国家',
  xzgj: '选择国家',
  zg: '中国',
  tgfwh: '通告服务号',
  z: '赞',
  tj_2: '推荐',
  ly_1: '留言',
  rhhqxhslj: '如何获取小红书链接',
  rhhqdylj: '如何获取抖音链接',
  rhhq: '如何获取',
  lj: '链接',
  dyb: '第一步',
  deb: '第二步',
  dsb: '第三步',
  dsib: '第四步',
  gz_1: '关注',
  jrybmcs: '今日已报名次数',
  yxqz: '有效期至',
  qxf: '去续费',
  ndvipjrdqqjsxf: '您的VIP今日到期，请及时续费',
  ckviptc: '查看 VIP 套餐',
  jrtclj: '进入套餐链接',
  kthyk: '开通会员卡',
  tyvip: '体验VIP',
  tygjtq: '体验高级特权',
  kt: '开通',
  tbye: '团币余额',
  djstb: '待结算团币',
  ljjstb: '累计结算团币',
  dhsc: '兑换商城',
  wdqb: '我的钱包',
  yhk: '银行卡',
  dz: '地址',
  qb_1: '全部',
  kbm: '可报名',
  afbsj: '按发布时间',
  ygq: '已过期',
  qxgz: '取消关注',
  zwgz: '暂无关注',
  sfqxgzgtgz: '是否取消关注该通告主',
  bzgz: '不再关注',
  jxgz: '继续关注',
  wdzj: '我的足迹',
  qy: '权益',
  tz: '通知',
  wdzy: '我的主页',
  tgzkk: '通告主开卡',
  hqtgzk: '获取通告主卡',
  qkk: '去开卡',
  zdwdtg: '置顶我的通告',
  ppf: '品牌方',
  dyygs: '代运营公司',
  gr: '个人',
  ds: '电商',
  rzz: '认证中',
  rzsb: '认证失败',
  wrztgz: '未认证通告主',
  qxzgj: '请选择国家',
  sjr: '收件人',
  qsryb: '请输入邮编',
  xxdz: '详细地址',
  cs: '城市',
  xzcs: '选择城市',
  swmr: '设为默认',
  bjdz: '编辑地址',
  zxq: '直辖区',
  mr: '默认',
  nhmytjdz: '您还没有添加地址',
  qtj: '去添加',
  mpxx_1: '名片信息',
  qxzpt: '请选择平台',
  mppt: '名片平台',
  djqhpt: '点击切换平台',
  qtx_1: '请填写',
  xts: '小贴士',
  dyfzdljxysdqmwzbf: '抖音复制的链接需要删掉前面文字部分',
  ljznl: '链接在哪里',
  hzbj: '合作报价',
  sdzbj: '商单自报价',
  hzfs: '合作方式',
  txhzfs: '填写合作方式',
  khzdrly: '可合作达人领域',
  lybq: '领域标签',
  qxzlybq: '请选择领域标签',
  zd_1: '最多',
  g: '个',
  zhjt: '账号截图',
  qsczhjt: '请上传账号截图',
  scd: '上传的',
  ymjtbxsdqmpdydzh: '页面截图必须是当前名片对应的账号',
  qwbscnbrdzh: '请务必上传您本人的账号',
  qqbjtqxwzl: '请确保截图清晰无遮拦',
  xxwz: '信息完整',
  bhtx: '包含头像',
  fss: '粉丝数',
  dzsdgjxx: '点赞数等关键信息',
  tjrz: '提交认证',
  gly_1: '个领域',
  mpxq: '名片详情',
  gxsj: '更新时间',
  sdgx: '手动更新',
  zy: '主页',
  dz_1: '点赞',
  kdzbj: '客单自报价',
  sxly: '所选领域',
  ptpphzrdxtwb: '平台品牌合作人的选填文本',
  yjzs: '有就展示',
  mxjbzs: '没写就不展示',
  swbmmr: '设为报名默认',
  bjmp: '编辑名片',
  sjzbj: '商家自报价',
  ptpphzrd: '平台品牌合作人等',
  scmp: '删除名片',
  qsrlybq: '请输入领域标签',
  qryscbq: '确认要删除标签',
  mplb: '名片列表',
  nhmytjmp: '您还没有添加名片',
  rzytg: '认证已通过',
  rzybh: '认证已驳回',
  wrz: '未认证',
  dsh: '待审核',
  qxzshtgdmp: '请选择审核通过的名片',
  cxsh: '重新审核',
  fhyzdznylzmp: '非会员最多只能有两张名片',
  sfyqmhy: '是否要去买会员',
  qmhyy: '去买会员页',
  xzpt: '选择平台',
  tbggtx: '同步谷歌头像',
  tbcg: '同步成功',
  ytbggtx: '已同步谷歌头像',
  gh: '更换',
  xrsc: '新人手册',
  lxkf: '联系客服',
  tkgz: '条款规则',
  wx: '微信',
  nhsy: '您还剩余',
  ztgq: '张通告券',
  z_1: '张',
  lkgm: '立刻购买',
  tgqgmxy: '通告券购买协议',
  q_1: '券',
  qhq: '去获取',
  lx_2: '类型',
  zwgmjl: '暂无购买记录',
  tgqgmjl: '通告券购买记录',
  ygm: '已购买',
  shwtg: '审核未通过',
  ytg: '已通过',
  tbjs: '团币结算',
  nsqd: '您申请的',
  jszzshz: '结算正在审核中',
  qnxdd: '请耐心等待',
  yjjswc: '已经计算完成',
  zwxx: '暂无消息',
  shsj: '审核时间',
  hd: '好的',
  hg: '回关',
  zwxxx: '暂无新消息',
  drgcxx: '达人广场消息',
  h_1: '号',
  zlzszxytxx: '这里展示最新一条信息',
  jj_1: '仅仅',
  lt: '聊天',
  qkdltjljwfhf: '清空的聊天记录将无法恢复',
  qjscz: '请谨慎操作',
  qrqk: '确认清空',
  zzqk: '正在清空',
  ltjlyqk: '聊天记录已清空',
  jl: '娇兰',
  zwhd: '暂无活动',
  xhdbt: '新活动标题',
  zlzsxhdjjdfzxwa: '这里展示新活动简介等辅助型文案',
  sgjbxbptgdhdbt: '水光净白小白瓶推广的活动标题',
  zlzshdjjdfzxwa: '这里展示活动简介等辅助型文案',
  glytz: '管理员通知',
  fssj: '发送时间',
  qdyc: '确定移除',
  m_1: '吗',
  sjhcdbzq: '手机号长度不正确',
  xy: '协议',
  lxdh: '电话',
  lxyx: '联系邮箱',
  bd: '绑定',
  bbh: '版本号',
  qdytcm: '确定要退出吗',
  tc: '退出',
  xz_1: '新增',
  qxzs: '请选择省',
  s_1: '市',
  q_2: '区',
  zjs: '浙江省',
  s_2: '省',
  ws: '我是',
  rzzn: '认证指南',
  ptbhgkyhysxx: '平台不会公开用户隐私信息',
  jxyyzsf: '仅限于验证身份',
  zzrz: '资质认证',
  sfrz: '身份认证',
  sbzcz: '商标注册证',
  yyzz: '营业执照',
  ppm: '品牌名',
  gsqc: '公司全称',
  hy: '行业',
  ly_2: '领域',
  qywx: '企业微信',
  ddgrzly: '钉钉个人资料页',
  zzzm: '在职证明',
  xbhxm: '需包含姓名',
  gsmhzw: '公司名和职位',
  zzzmxjgsqzthsgz: '在职证明需加盖申请主体红色公章',
  bzc: '不支持',
  z_2: '章',
  dzz: '电子章',
  bmzjzyz: '部门章及专用章',
  xm_1: '姓名',
  sfzh: '身份证号',
  mysfz: '没有身份证',
  kglybzly: '可管理员备注留言',
  wcnyszlzskx: '我承诺以上资料真实可信',
  dphtjt: '店铺后台截图',
  dpwljt: '店铺物流截图',
  dpmc: '店铺名称',
  dplj: '店铺链接',
  yzxgflfg: '依照相关法律法规',
  qxyzsf: '请先验证身份',
  sqrz: '申请认证',
  nyjs: '您已经是',
  rztgz: '认证通告主',
  nytjrzsq: '您已提交认证申请',
  qddsh: '请等待审核',
  shbjj: '审核被拒绝',
  rgnytgzjgsdcp: '如果你要推广自己公司的产品',
  rgnszdgsxytgqtgsdcp: '如果你所在的公司需要推广其他公司的产品',
  rgnsygrmytgqtgsdcp: '如果你是以个人名义推广其他公司的产品',
  rgnstb: '如果你是淘宝',
  tm: '天猫',
  jdddssj: '京东等电商商家',
  xtgzjdpdcp: '想推广自己店铺的产品',
  yppfgtjl: '与品牌方沟通记录',
  xzsqsmb: '下载授权书模板',
  pptfsq: '品牌投放授权',
  ht: '合同',
  xjgsqzthsgz: '需加盖申请主体红色公章',
  sqgsqc: '授权公司全称',
  qxlh: '取消拉黑',
  ygz: '已关注',
  qrqxlhgtgz: '确认取消拉黑该通告主',
  jjxzsgtgzdtg: '将继续展示该通告主的通告',
  jxlh: '继续拉黑',
  qxlhcg: '取消拉黑成功',
  qrlhgtgz: '确认拉黑该通告主',
  jbzzsgtgzdtg: '将不再展示该通告主的通告',
  lh: '拉黑',
  blh: '不拉黑',
  lhcg: '拉黑成功',
  zx_1: '中心',
  hjbj: '好久不见',
  ndhyygq: '您的会员已过期',
  ljgm: '立即购买',
  ktqyd: '开通前阅读',
  hyfwxy: '会员服务协议',
  hyqydb: '会员权益对比',
  qydb: '权益对比',
  fhy: '非会员',
  yfhy: '月付会员',
  j_1: '仅',
  jfhy: '季付会员',
  nfhy: '年付会员',
  mrjstgsx: '每日解锁通告上限',
  wx_1: '无限',
  mrkbmsx: '每日可报名上限',
  gjrw: '高价任务',
  xlrw: '限量任务',
  rwtjsfyx: '任务推荐算法优先',
  yxppgzhrw: '优先匹配高转化任务',
  rwss: '任务搜索',
  dy_2: '订阅',
  zcgjc: '支持关键词',
  hyfl: '行业分类',
  mggty: '免广告体验',
  dsjzhbd: '多社交账号绑定',
  r_2: '如',
  zskfzc: '专属客服支持',
  xszc: '小时支持',
  rwshyxcl: '任务审核优先处理',
  rw: '任务',
  xsnsh: '小时内审核',
  hyjfjlfb: '会员积分奖励翻倍',
  zshz: '专属徽章',
  rwtgtsbg: '任务推广提升曝光',
  yxtj: '优先推荐',
  zp_1: '作品',
  qxtyhyfwxy: '请先同意会员服务协议',
  qxzygmdhyfa: '请选择要购买的会员方案',
  wxts: '温馨提示',
  byebz: '币余额不足',
  qdyqczm: '确定要去充值吗',
  tjxk: '添加新卡',
  yhxx: '银行信息',
  m_2: '名',
  qsrm: '请输入名',
  xs_1: '姓氏',
  qsrxs: '请输入姓氏',
  kh: '卡号',
  qsrkh: '请输入卡号',
  sxrq: '失效日期',
  qsrrq: '请输入日期',
  qsrsjrxm: '请输入收件人姓名',
  qsrdz: '请输入地址',
  qxzcs: '请选择城市',
  wsdk: '万事达卡',
  zgyh: '中国银行',
  cxk: '储蓄卡',
  payh: '平安银行',
  hxyh: '华夏银行',
  qdysczzyhkm: '确定要删除这张银行卡吗',
  sr_1: '收入',
  zc_2: '支出',
  zd_2: '账单',
  wdye: '我的余额',
  djje_1: '其中冻结额度',
  djmx: '冻结明细',
  ckmx: '查看明细',
  djsj: '冻结时间',
  djje: '冻结金额',
  tgmc: '通告名称',
  txed: '提现额度',
  kydh: '可以兑换',
  yhkh: '银行卡号',
  txxx_1: '提现信息',
  yhkszgj: '银行卡所在国家',
  yhmc: '银行名称',
  zhcyrxm: '账户持有人姓名',
  dm: '代码',
  tkje: '提款金额',
  zt_1: '状态',
  shbh: '审核驳回',
  sxf: '手续费',
  jx: '继续',
  czcg_1: '充值成功',
  jxcz: '继续充值',
  wc: '完成',
  czfs: '充值方式',
  qxzyhk: '请选择银行卡',
  dcjyesx: '单次交易额上限',
  czje: '充值金额',
  yxsrsz: '允许输入数字',
  dqdfhdcszjp: '调起带符号的纯数字键盘',
  qsrje: '请输入金额',
  xe: '限额',
  dqzhtbye: '当前账户团币余额',
  ljcz: '立即充值',
  pfyh: '浦发银行',
  zsyh: '招商银行',
  qsrczje: '请输入充值金额',
  yhdhk: '银行电汇款',
  qxzyhszgj: '请选择银行所在国家',
  yhszgj: '银行所在国家',
  qtxyhmc: '请填写银行名称',
  qsryhmc: '请输入银行名称',
  yhfhdz: '银行分行地址',
  qsryhfhdz: '请输入银行分行地址',
  qtxzhcyrxm: '请填写账户持有人姓名',
  qsrzhcyrxm: '请输入账户持有人姓名',
  gjyhzh: '国际银行账号',
  qsrtkje: '请输入提款金额',
  xyxh: '需要消耗',
  txsqytj: '提现申请已提交',
  hdmc: '活动名称',
  ye: '余额',
  jbcttg: '举报此条通告',
  xzjbly: '选择举报理由',
  jbyy: '举报原因',
  txjbyy: '填写举报原因',
  jbcg: '举报成功',
  szh: '设置后',
  xthzdsxfhyqdbmbz: '系统会自动筛选符合要求的报名博主',
  drly: '达人领域',
  qg: '全国',
  wctgrw: '完成通告任务',
  fh: '返回',
  jxlnky: '接下来你可以',
  qsrwz: '请输入网址',
  bjtjcg: '笔记提交成功',
  bjytj: '笔记已提交',
  yhz: '已合作',
  ygs: '已过审',
  dpj: '待评价',
  yjtbjz: '佣金团币价值',
  bj_1: '笔记',
  fkpz: '付款凭证',
  kzybmlbplcz: '可在已报名列表批量操作',
  qbhs: '全部合适',
  fzmdlj: '复制名单链接',
  zwkf: '暂未开放',
  dqmykyplczdsj: '当前没有可以批量操作的数据',
  plcz: '批量操作',
  qdyzxcczm: '确定要执行此操作吗',
  dzsl: '点赞数量',
  scsl: '收藏数量',
  ysx: '已筛选',
  qytgzqrhz: '请与通告主确认合作',
  qddtgztyhz: '请等待通告主同意合作',
  ytgzlyl: '与通告主聊一聊',
  ddsjxx: '等待商家消息',
  sjhzdlxhsrx: '商家会主动联系合适人选',
  sdcpcl: '收到测评材料',
  cp: '产品',
  ayqfbjhsp: '按要求发笔记或视频',
  fsjbjlj: '发商家笔记链接',
  lqgf: '领取稿费',
  gzgzh: '关注公众号',
  jsjstx: '及时接受提醒',
  spxq: '商品详情',
  kytbs: '可用团币数',
  ljdh: '立即兑换',
  xzdhsl: '选择兑换数量',
  dh_1: '兑换',
  qxzdhsl: '请选择兑换数量',
  dhcg: '兑换成功',
  sy: '剩余',
  dhjl: '兑换记录',
  xx_1: '小小',
  bggcdl: '白刚刚抽到了',
  cdl: '抽到了',
  jfcjgz: '积分抽奖规则',
  jfdhsp: '积分兑换商品',
  qdh: '去兑换',
  zwsp: '暂无商品',
  xxcy: '谢谢参与',
  dhsj: '兑换时间',
  ddbh: '订单编号',
  dhsl: '兑换数量',
  sf: '实付',
  zwdhsj: '暂无兑换数据',
  cj_1: '抽奖',
  zjsj: '中奖时间',
  tbjz: '团币价值',
  zwcjsj: '暂无抽奖数据',
  gxzj: '恭喜中奖',
  hyhwzj: '很遗憾未中奖',
  yzlycm: '要再来一次吗',
  kxsx: '开心收下',
  yy_zh: '中文',
  yy_en: '英文',
  yy_sp: '西班牙文',
  sys_msg_type_101: '通告主认证通过',
  sys_msg_type_102: '通告主认证拒绝',
  sys_msg_type_103: '团币结算审核等',
  sys_msg_type_104: '通用「审核中/待审核」类',
  sys_msg_type_105: '平台名片审核通过',
  sys_msg_type_106: '平台名片审核拒绝',
  sys_msg_type_107: '通告审核通过',
  sys_msg_type_108: '通告审核拒绝',
  sys_msg_type_109: '提现审核通过',
  sys_msg_type_110: '提现审核拒绝',
  sys_msg_type_111: '提现审核中',
  sys_msg_type_201: '博主报名成功',
  sys_msg_type_202: '标记合适等',
  sys_msg_type_203: '报名拒绝等',
  sys_msg_type_204: '名额已满',
  sys_msg_type_301: '新粉丝/新关注通知',
  sys_msg_type_302: '通告被收藏',
  sys_msg_type_401: '管理端系统通知',
  sys_msg_type_402: '活动通知',
  sys_msg_type_403: '警告通知',
  sys_msg_reason_none: '无',
  sys_msg_unknown_user: '未知用户',
  sys_msg_unknown_announcement: '未知通告',
  sys_msg_content_101: '恭喜您，您的通告主认证申请已通过审核！',
  sys_msg_content_102_plain: '很遗憾，您的通告主认证申请未通过审核。',
  sys_msg_content_102_reason:
    '很遗憾，您的通告主认证申请未通过审核。原因：{reason}',
  sys_msg_content_104_reviewing: '您的通告「{name}」正在审核中',
  sys_msg_content_104_pending: '您的通告「{name}」待审核',
  sys_msg_content_105: '您的{platform}平台名片已审核通过',
  sys_msg_content_106: '您的{platform}平台名片审核未通过，原因：{reason}',
  sys_msg_content_107: '您的通告「{name}」已审核通过',
  sys_msg_content_108_no_reason: '您的通告「{name}」审核未通过',
  sys_msg_content_108_with_reason: '您的通告「{name}」审核未通过，原因：{reason}',
  sys_msg_content_109:
    '您的提现申请（金额：{amount} 欧元）已审核通过，预计3个工作日内到账',
  sys_msg_content_110:
    '您的提现申请（金额：{amount} 欧元）审核未通过，原因：{reason}',
  sys_msg_content_111:
    '您的提现申请（金额：{amount} 欧元）正在审核中，请耐心等待',
  sys_msg_content_201: '博主 {nickname} 报名了您的通告：{title}',
  sys_msg_content_204: '通告「{name}」合适名额已满，感谢您的报名。',
  sys_msg_content_301: '用户 {operatorNickname} 关注了您',
  sys_msg_content_302: '用户 {operatorNickname} 收藏了您的通告 {activityName}',
  ...apiMsgKeysFlatZhCn
};
